// extracted by mini-css-extract-plugin
export var addButton = "_4k-d";
export var bullets = "_4k-e";
export var compact = "_4k-2";
export var container = "_4k-j";
export var extendedWarrantyModal = "_4k-f";
export var learn = "_4k-l";
export var learnMore = "_4k-g";
export var offeringOption = "_4k-3";
export var offeringPrice = "_4k-8";
export var offeringSubtitle = "_4k-7";
export var offeringTitle = "_4k-6";
export var offeringsContainer = "_4k-0";
export var pdpTilesBackground = "_4k-n";
export var plan = "_4k-m";
export var regular = "_4k-1";
export var remove = "_4k-k";
export var seeDetailsIcon = "_4k-i";
export var seeDetailsLink = "_4k-h";
export var selectedOption = "_4k-4";
export var shieldIcon = "_4k-b";
export var shieldIconCompact = "_4k-c";
export var subtitle = "_4k-a";
export var title = "_4k-9";
export var unselectedOption = "_4k-5";